<template>
  <div>
    <fieldset class="form__field-group">
      <legend class="h4">
        Velg antall panel
        <question-icon
          @onClick="showModal = true"
          :withTooltip="false"
        ></question-icon>
      </legend>
      <div class="selectable-boxes-container">
        <div
          class="selectable-boxes-wrapper"
          :key="panel.id"
          v-for="panel in validPanels"
        >
          <div
            v-if="
              (panel.antallPaneler >= 11 &&
                panelType.Wp >= 395 &&
                !deliveryPoint.numberOfPhases) ||
                (panel.antallPaneler >= 14 &&
                  panelType.Wp >= 365 &&
                  !deliveryPoint.numberOfPhases)
            "
            class="recommended-tab"
            :class="{ selected: numberOfSolarPannels === panel.antallPaneler }"
          >
            KREVER 3-FASE
          </div>
          <div
            class="selectable-boxes"
            :class="{
              selected: numberOfSolarPannels === panel.antallPaneler,
              recommended: panel.anbefalt,
            }"
            @click="selectPanel(panel)"
          >
            <div>{{ panel.antallPaneler }}</div>
            <i class="material-icons" hidden>check</i>
          </div>
        </div>
      </div>
    </fieldset>

    <div
      class="modal"
      :class="{ 'is-visible': showModal }"
      id="modal1"
      @keyup.esc="showModal = false"
      @click.self="showModal = false"
      tabindex="0"
    >
      <div class="modal-dialog">
        <header class="modal-header">
          Krav om 3-fas strømanlegg
          <button
            type="button"
            class="close-modal"
            aria-label="close modal"
            @click="showModal = false"
          >
            ✕
          </button>
        </header>
        <section class="modal-content">
          <legend class="h5">Krav om 3-fas strømanlegg</legend>
          <p>
            For å installere anlegg som har flere enn 14 paneler må du ha
            installert 3-fas strømanlegg. Informasjon om dette finner du på
            kursbetegnelsene i sikringsskapet.<br />
            Finner du ikke dette, vennligst ta kontakt med oss.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import QuestionIcon from './QuestionIcon.vue';

export default {
  name: 'NumPanels',
  components: {
    QuestionIcon,
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    offer() {
      if (!store.state.offer) {
        return;
      }

      if (!store.state.offer.paneler) {
        return;
      }

      if (!store.state.offer.paneler.length) {
        store.dispatch('resetPanelsVal');
        return;
      }

      if (store.state.offer.paneler.length === 1) {
        store.state.offer.paneler[0].anbefalt = true;
        store.commit('setPanelsVal', {
          panelsVal: store.state.offer.paneler[0],
        });
        return;
      }

      const anbefalt = [8, 10, 12, 14];
      const highestRecomended =
        store.state.offer.paneler.length >= anbefalt.length
          ? anbefalt[anbefalt.length - 1]
          : anbefalt[store.state.offer.paneler.length - 1];

      store.state.offer.paneler = store.state.offer.paneler.map(panel => {
        panel.anbefalt = panel.antallPaneler === highestRecomended;
        return panel;
      });

      const selectedPanel =
        Object.keys(this.selected).length !== 0
          ? store.state.offer.paneler.find(
              panel => panel.antallPaneler === this.selected.antallPaneler
            )
          : store.state.offer.paneler.find(panel => panel.anbefalt);

      store.commit('setPanelsVal', {
        panelsVal:
          selectedPanel ||
          store.state.offer.paneler.find(
            panel => panel && panel.anbefalt === true
          ),
      });
    },
  },
  methods: {
    selectPanel(panel) {
      store.commit('setPanelsVal', {
        panelsVal: panel,
      });
      store.commit('setNumberOfSolarPannels', panel.antallPaneler);
    },
  },
  computed: {
    currentPageIndex() {
      return store.state.currentPageIndex;
    },
    numberOfSolarPannels() {
      return store.state.panelsVal.antallPaneler;
    },
    offer() {
      return store.state.offer;
    },
    panelType() {
      return store.state.solarPanelType;
    },
    selected: {
      get() {
        if (!store.state.panelsVal) {
          return {};
        }

        return store.state.panelsVal;
      },
    },
    // In the case of less than 3 phases, the maximum capacity is 14 panels. Higher quantities is then being filtered out.
    validPanels() {
      if (
        store.state.offer.paneler &&
        store.state.smsLogin.deliveryPoint.numberOfPhases &&
        store.state.smsLogin.deliveryPoint.numberOfPhases < 3
      ) {
        return store.state.offer.paneler.filter(
          panel => panel.antallPaneler <= 14
        );
      }

      return store.state.offer.paneler;
    },
    deliveryPoint() {
      return store.state.smsLogin.deliveryPoint;
    },
  },
};
</script>

<style scoped>
.form__field-group {
  margin: 1.5em 0;
}

.form__field--radio {
  background-color: #0095d6;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0.5em;
}

.form__field--radio li {
  margin: 1em;
  flex-grow: 1;
}

.form__field--radio label {
  width: 100%;
  margin: 0;
  font-weight: 600;
  color: #0095d6;
  text-align: center;
  line-height: 0;
  background-color: #99d5ef;
  display: flex;
}

.form__field--radio label span {
  margin: 0;
  padding: 1em;
  width: 100%;
  height: 100%;
}

.form__field--radio label span:before,
.form__field--radio label span:after {
  display: none;
}
.form__field--radio label input:checked + span {
  background-color: #fff;
}

.recommended-tab {
  font-size: 12px;
  font-weight: 600;
  height: fit-content;
  width: fit-content;
  padding: 0.3rem 0.6rem 0;
  border-radius: 0.5rem 0.5rem 0 0;
  margin-left: auto;
  margin-right: 0;
  background-color: #003451;
  color: #fff;
}

.recommended-tab.selected {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.4);
  transition: box-shadow 0.1s ease-out;
}
</style>
